import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { WsNavigatorService, NavigationState } from '@web/app/services/ws-navigator.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'ws-page-subheader',
  templateUrl: './ws-page-subheader.component.html',
  styleUrls: ['./ws-page-subheader.component.scss']
})
export class WsPageSubHeaderComponent implements OnInit, OnDestroy {

  // Esponiamo direttamente l'observable per usare l'async pipe nel template
  navigationState$: Observable<NavigationState>;

  /** On host so app shell `:has()` can grow `.content-wrapper-subtitle` despite encapsulation. */
  @HostBinding('class.ws-page-subheader--stacked')
  stacked = false;

  private stackedSub?: Subscription;

  constructor(
    private location: Location,
    private router: Router,
    private wsNavigatorService: WsNavigatorService
  ) {
    // L'async pipe gestirà automaticamente la subscription e il change detection
    this.navigationState$ = this.wsNavigatorService.navigationState$;
  }

  ngOnInit() {
    this.stackedSub = this.navigationState$.subscribe((navState) => {
      const both =
        !!navState?.showBreadcrumb &&
        (!!navState.showSubtitle || !!navState.subtitle);
      // Route `stackedSubheader` covers pages that clear shell subtitle but keep a local title (ecommerce wizard).
      this.stacked = both || !!navState?.stackedSubheader;
    });
  }

  ngOnDestroy() {
    if (this.stackedSub) {
      this.stackedSub.unsubscribe();
    }
  }

  goBack(): void {
    this.location.back();
  }
}
